// extracted by mini-css-extract-plugin
export default {"message-box":"ErrorPage_message-box__x2prz"};